import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducer(organization_id, producer_id) {
    return RequesterV1.get(
      `organization/partners/producers/manage_producer/${organization_id}/producer/${producer_id}`
    );
  },
  fetchProducerCropFields(organization_id, producer_id) {
    return RequesterV1.get(
      `organization/partners/producers/manage_producer/${organization_id}/producer_crop_fields/${producer_id}`
    );
  },
  fetchAttributeProducers(organization_id) {
    return RequesterV1.get(
      `organization/partners/producers/manage_producer/${organization_id}/attribute_producers`
    );
  },
  createProducer(organization_id, producer) {
    return RequesterV1.post(
      `organization/partners/producers/manage_producer/${organization_id}/create_producer`,
      { producer: producer }
    );
  },
  updateProducer(organization_id, producer_id, producer) {
    return RequesterV1.post(
      `organization/partners/producers/manage_producer/${organization_id}/update_producer/${producer_id}`,
      { producer: producer }
    );
  },
  destroyProducer(organization_id, producer_id) {
    return RequesterV1.get(
      `organization/partners/producers/manage_producer/${organization_id}/destroy_producer/${producer_id}`
    );
  }
};
